import * as c from '../../../../../../constants.jsx';
import GeneticPanelsCardTemplate from "../../../../../../components/CockpitCards/GeneticPanelsCardTemplate.jsx";

export default function HematologicCard() {

return(
<>

<GeneticPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/hematologic`}

  panel_name = { "HEMATOLOGIC DISORDER PANEL" }
  panel_subtext = {"This panel is based on expert-reviewed gene and disease associations from the ClinGen Evidence Repository."}

/>

</> 
)}